import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const categories = [
  {
    title: "Nettoyage costumes & tailleurs",
    keywords: "Costume homme 2/3 pièces, costume de mariage, smoking, tailleur femme jupe, tailleur pantalon, redingote."
  },
  {
    title: "Nettoyage robes de mariée & cérémonie",
    keywords: "Robe de mariée dentelle, robe de soirée, robe de cocktail, robe longue, robe pailletée, tenue de cérémonie."
  },
  {
    title: "Nettoyage manteaux & doudounes",
    keywords: "Manteau laine, cachemire, trench, caban, pardessus. Doudoune plume, duvet, synthétique, parka, anorak."
  },
  {
    title: "Nettoyage cuir & blousons",
    keywords: "Veste cuir, blouson motard, manteau cuir. Cuir protégé, nourri, assoupli."
  },
  {
    title: "Accessoires : casquettes, baskets, cravates",
    keywords: "Casquettes, bonnets, baskets blanches, sneakers, tennis, cravates, écharpes, foulards."
  },
  {
    title: "Literie : couettes, couvertures, dessus-de-lit",
    keywords: "Couettes (jusqu'à 240×260), couvertures, plaids, dessus-de-lit, jetés de lit, édredons, draps, oreillers."
  }
];

export const HomeSeoStrip = () => {
  return (
    <section className="py-14 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50 border-t border-blue-100" data-testid="home-seo-strip">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
            Pressing de confiance pour tous vos vêtements
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Vous cherchez à faire nettoyer un <strong>costume, un tailleur, une robe de mariée, un manteau, une doudoune, une casquette, des baskets, une couette, une couverture ou un dessus-de-lit</strong> ? <strong>AQUABLUENET</strong> est votre pressing de référence en Essonne (91) à <strong>Longpont-sur-Orge</strong> et <strong>Mennecy</strong>.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {categories.map((cat) => (
            <div key={cat.title} className="bg-white rounded-xl p-5 border border-blue-100 hover:border-[#0205B3] hover:shadow-md transition-all">
              <h3 className="text-base font-bold text-[#0205B3] mb-2">{cat.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{cat.keywords}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/services">
            <button className="inline-flex items-center gap-2 bg-[#0205B3] hover:bg-[#0205B3]/90 text-white font-bold px-6 py-3 rounded-full transition-colors" data-testid="home-seo-cta">
              Voir tous nos services en détail
              <ChevronRight className="h-5 w-5" />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};
